<script setup lang="ts">
import SensorNotificationBatteryAlert from '@/components/OperationOfficeForms/SensorNotificationBatteryAlert.vue';
import getOperationOfficeResponse from "@/types/responses/getOperationOffice"
import { computed } from 'vue'

const emits = defineEmits(['update:modelValue']);

const props = defineProps<{
  modelValue: getOperationOfficeResponse
  windowInnerWidth: number
}>()

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

</script>
<template>
  <SensorNotificationBatteryAlert
    class="mb-6"
    v-model="modelValue.sensor_notification_battery_level"
    :windowInnerWidth="props.windowInnerWidth"
  />
</template>
